import {ReactNode} from 'react'
import cn from 'clsx'
import {Tooltip} from 'antd'

import './CentsMoney.scss'
import Text, {TextProps} from 'common/components/typography/Text'
import {formatMoney} from 'common/helpers'
import {MoneyFormatOptions} from 'common/types'

interface CentsMoneyProps extends Omit<TextProps, 'children'> {
  value: number
  prefix?: boolean
  parentheses?: boolean
  tooltip?: ReactNode
}

export default function CentsMoney({
  value,
  className,
  prefix,
  parentheses,
  tooltip,
  ...props
}: CentsMoneyProps) {
  let moneyOptions: MoneyFormatOptions = {
    cents: true,
  }
  if (prefix !== undefined) moneyOptions.prefix = prefix
  if (parentheses !== undefined) moneyOptions.parentheses = parentheses
  const valueParts = formatMoney(value, moneyOptions).split('.')

  const amountElement = (
    <>
      <span>{valueParts[0]}</span>
      <span className="CentsMoney-End">.{valueParts[1]}</span>
    </>
  )

  return (
    <Text {...props} className={cn(className, !value && 'CentsMoney_zero')}>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <span>{amountElement}</span>
        </Tooltip>
      ) : (
        amountElement
      )}
    </Text>
  )
}
